import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../components/common/StyledToolTip";
import { ToggleRenderer } from "../../../components/dataGrid/cellRenderer";
import styles from "./styles";

const toggleMapLegend = ({ stack, isMapLegendEnabled, toggleMapLegend }) => {
  stack.layoutManager.eventHub.emit("mapLegend", !isMapLegendEnabled);

  toggleMapLegend && toggleMapLegend(!isMapLegendEnabled);
};
const MapLegend = ({ classes, ...props }) => {
  const label = `${props.isMapLegendEnabled ? "Disable" : "Enable"} Map Legend`;
  return (
    <Tooltip title="Enable/Disable Map Legend">
      <div
        className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${props.isMenuItem ? classes.toggleAnimationButtonMenu : ""} `}
      >
        <div className={classes.toggleText}>{label}</div>
        <ToggleRenderer
          value={props.isMapLegendEnabled}
          onChange={() => toggleMapLegend(props)}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(MapLegend);
